<template lang="pug">
  .homepage.mx-auto(:class="[spacingTop, spacingBottom, container]" v-if="contents && contents.length")
    .wrap
      .block.block-1(ref="container")
          ImageElement(
            :content="image1"
            :max-width="containerWidth"
            :brand="brand1"
          )
      .block.block-2(ref="container")
          ImageElement(
            :content="image2"
            :max-width="containerWidth"
            :brand="brand2"
          )
      .block.block-3(ref="container")
          ImageElement(
            :content="image3"
            :max-width="containerWidth"
            :brand="brand3"
          )
</template>

<script>
import { debounce } from "@/helpers";

import ImageElement from "./Partials/Image";

export default {
  name: "Homepage",
  data() {
    return {
      containerWidth: undefined
    };
  },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  components: {
    ImageElement
  },
  computed: {
    contents() {
      return this.section.contents || [];
    },
    content() {
      return this.contents.find(content => content.key === "content");
    },
    image1() {
      return this.contents.find(content => content.key === "image-1");
    },
    brand1() {
      return this.contents.find(content => content.key === "image-1-brand");
    },
    image2() {
      return this.contents.find(content => content.key === "image-2");
    },
    brand2() {
      return this.contents.find(content => content.key === "image-2-brand");
    },
    image3() {
      return this.contents.find(content => content.key === "image-3");
    },
    brand3() {
      return this.contents.find(content => content.key === "image-3-brand");
    },

    container() {
      let container = "container";

      if (this.section.settings && this.section.settings.length) {
        const setting = this.section.settings.find(
          setting => setting.key === "container"
        );
        if (setting && setting.value !== undefined) container = setting.value;
      }
      return container;
    },

    spacingTop() {
      let spacingTop = "spacingTopStandard";

      if (this.section.settings && this.section.settings.length) {
        const setting = this.section.settings.find(
          setting => setting.key === "spacingTop"
        );
        if (setting && setting.value !== undefined) spacingTop = setting.value;
      }
      return spacingTop;
    },

    spacingBottom() {
      let spacingBottom = "spacingBottomStandard";

      if (this.section.settings && this.section.settings.length) {
        const setting = this.section.settings.find(
          setting => setting.key === "spacingBottom"
        );
        if (setting && setting.value !== undefined)
          spacingBottom = setting.value;
      }
      return spacingBottom;
    }
  },
  mounted() {
    const calculateMaxWidth = () => {
      if (this.$refs.container) {
        const style = getComputedStyle(this.$refs.container);
        this.containerWidth = this.$refs.container.clientWidth;
        this.containerWidth -=
          parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      }
    };

    window.addEventListener("resize", debounce(calculateMaxWidth, 200));
    calculateMaxWidth();
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.homepage
  .wrap
    @screen sm
      @apply grid grid-rows-2 grid-cols-2 grid-flow-col gap-2

    .block
      @apply bg-gray-100 mb-2
      @screen sm
        @apply mb-0
    .block-1
      @apply row-span-2
    .block-2
      @apply row-span-1
      & ::v-deep
        .brand
          max-height: 70px
    .block-3
      @apply row-span-1
</style>
